import { format } from "date-fns/format";
import { ptBR } from "date-fns/locale/pt-BR";
import { GrDownload } from "react-icons/gr";
import { RealizationEvItem } from "types/realization";
import { FaPlay } from "react-icons/fa6";
import { parseISO } from "date-fns";
import { useEffect, useState } from "react";
import {
  getConfirmedPlayers,
  getPlayerslist,
} from "services/realization.service";
import { useModal } from "context/ModalContext/Modal.context";
import ModalParticipantsEvaluated from "./Modal/Evaluated";
import { FaTrophy } from "react-icons/fa";
import { useLocation } from "react-router-dom";

interface Options {
  isBossEvaluator?: boolean;
  showEvaluation?: boolean;
  onlyResult?: boolean;
  data: RealizationEvItem;
  step?: number;
  isResult?: boolean;
}
const CardEvaluated = ({
  isBossEvaluator,
  onlyResult,
  data,
  step,
  isResult,
}: Options) => {
  const [confirmedPlayerList, setConfirmedPlayerList] = useState<any>([]);
  const [created, setCreated] = useState<string>("");
  const [result, setResult] = useState<string>("");
  const [teamData, setTeamData] = useState<any>([]);
  const [showDetail, setShowDetail] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const { showModal } = useModal();

  const location = useLocation();
  const isWinnersPage = location.pathname === "/winners";

  const Evaluation = () => {
    return (
      <>
        <p className="text-sm font-semibold text-black-bb">
          Avaliado como {data.evaluation == "relevant" && "relevante"}
          {data.evaluation == "very" && "muito relevante"}
          {data.evaluation == "extremaly" && "extremamente relevante"}
        </p>
      </>
    );
  };

  async function getPlayerList(idRealization: string) {
    try {
      setLoadingDetail(true);
      const list = await getPlayerslist(idRealization);
      const response = await getConfirmedPlayers(idRealization);
      const confirmedPlayers = response.confirmados.filter((id: string) =>
        list.team_data.some((player: any) => player.chave === id)
      );

      setConfirmedPlayerList(confirmedPlayers);
      setCreated(list.created);
      setResult(list.result);
      setTeamData(list.team_data);

      setShowDetail(true);
    } catch (e) {
      console.log(e);
    } finally {
      setLoadingDetail(false);
    }
  }

  useEffect(() => {
    if (showDetail) {
      showModal(
        "view-participants",
        <ModalParticipantsEvaluated
          documento={data.documento}
          inscricao_mat={data.inscricao_mat}
          inscricao_name={data.inscricao_name}
          owner={data.owner}
          owner_name={data.owner_name}
          category={data.categoria}
          data={data}
          created={created}
          result={result}
          team_data={teamData}
          confirmedPlayerList={confirmedPlayerList}
        />,
        "participants"
      );
    }
  }, [showDetail]);

  const viewParticipants = () => {
    getPlayerList(data.id_realizacao);
  };
  return (
    <article
      className={`flex flex-col card ${
        data.realization.classificada === true && isWinnersPage
          ? "winner-card"
          : ""
      } winner-step-${step || 0}`}
    >
      <div className={`flex justify-between items-start`}>
        {data.realization.classificada === true && isWinnersPage && (
          <div className="flex items-center gap-1 uppercase flag">
            <FaTrophy
              color={`${step == 2 ? "#111214" : "#F6F630"}`}
              width={24}
            />
            <span
              className={`text-sm font-bold font-bb ${
                step == 2 ? "text-black-bb" : "text-yellow-bb-1 "
              }`}
            >
              Classificada
            </span>
          </div>
        )}
        <div className="justify-start tag md:justify-end">
          {data.categoria && <span>{String(data.categoria)}</span>}
        </div>
        {!isBossEvaluator && !onlyResult && <Evaluation />}
      </div>
      <h2 className="mt-3 mb-2 text-lg font-medium font-bb text-black-bb">
        <strong>Realização: </strong>
        {data.title}
      </h2>

      <div className="flex-1 p-4 detail bg-gray-bb-3">
        <p className="text-sm font-bold text-black-bb">
          <strong>Cadastrado por</strong>
        </p>
        <p>
          {data.owner_name} ({data.owner}), em{" "}
          {data.dt_aceite
            ? format(
                typeof data.dt_aceite === "string"
                  ? parseISO(data.dt_aceite)
                  : new Date(data.dt_aceite),
                "dd 'de' MMMM 'de' yyyy",
                {
                  locale: ptBR,
                }
              )
            : "Data inválida"}
        </p>
        <p className="mt-4 text-sm font-bold text-black-bb">
          <strong>Detalhes da realização</strong>
        </p>
        <p dangerouslySetInnerHTML={{ __html: data.description }} />
        <p className="mt-4 text-sm font-bold text-black-bb">
          <strong>Participantes da realização mais votados</strong>
        </p>
        {data.indicados &&
          [...data.indicados]
            .sort((a, b) => a.nome.localeCompare(b.nome))
            .map((item) => (
              <p
                className="text-base text-gray-bb-2 font-bb"
                key={item.matricula}
              >
                <strong>
                  {item.nome}({item.matricula})
                </strong>
              </p>
            ))}
        {!!data.documento && data.documento.length > 0 && !isResult ? (
          <>
            <p className="mt-2 mb-2 text-sm font-bold text-black-bb">
              <strong>Documentação complementar da realização</strong>
            </p>
            {data.documento.map((item) => (
              <>
                {!!item && item !== null && (
                  <>
                    {item.type === "video" ? (
                      <div className="relative mt-6">
                        <div>
                          <button>
                            <a
                              href={item.file}
                              className="rounded-[4px] py-[14px] px-5 bg-gray-bb-2 text-white-bb-1 uppercase flex items-center gap-2 font-bold"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <FaPlay />
                              Ver vídeo
                            </a>
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="mt-6">
                        <button
                          className="rounded-[4px] py-[14px] px-5 bg-gray-bb-2 text-white-bb-1 uppercase flex items-center gap-2 font-bold"
                          onClick={() => {
                            window.open(item.file, "_blank");
                          }}
                        >
                          <GrDownload size={22} />
                          Download
                        </button>
                      </div>
                    )}
                  </>
                )}
              </>
            ))}
          </>
        ) : (
          <></>
        )}
      </div>

      {!isResult && (
        <div className="flex flex-col items-center justify-center gap-4 mt-4 view-more">
          <button
            className="px-4 py-3 font-bold uppercase text-blue-bb"
            onClick={viewParticipants}
          >
            {loadingDetail ? "Carregando..." : "Ver Mais"}{" "}
          </button>
        </div>
      )}
    </article>
  );
};

export default CardEvaluated;
